/**
 * The single route table shared by the browser router, the SSR entry, the
 * prerender script, and the SEO audit.
 *
 * `page` is the file name under src/pages. Public routes are prerendered to
 * static HTML at build time and hydrated in the browser. App routes are
 * client-only: they may show private event or account data and are never
 * rendered at build time.
 */
import { DEPRECATED_ROUTE_REDIRECTS, FORCE_NOINDEX_ROUTES } from "../seo/constants.js";

export const PUBLIC_ROUTES = [
  { path: "/", page: "Landing" },
  { path: "/pricing", page: "Pricing" },
  { path: "/about", page: "About" },
  { path: "/privacy", page: "Privacy" },
  { path: "/terms", page: "Terms" },
  { path: "/knowledge-base", page: "KnowledgeBase" },
  { path: "/faq", page: "FAQ" },
  { path: "/dj-request-app", page: "DjRequestApp" },
  { path: "/qr-code-song-requests", page: "QrCodeSongRequests" },
  { path: "/get-paid-song-requests", page: "GetPaidSongRequests" },
  { path: "/wedding-dj-song-requests", page: "WeddingDjSongRequests" },
  { path: "/karaoke-dj-app", page: "KaraokeDjApp" },
  { path: "/event-photo-wall", page: "EventPhotoWall" },
  { path: "/how-to-use-dj-request", page: "HowToUseDjRequest" },
  { path: "/dj-request-pricing", page: "DjRequestPricing" },
  { path: "/dj-request-features", page: "DjRequestFeatures" },
  { path: "/free-dj-request-app", page: "FreeDjRequestApp" },
  { path: "/song-request-app-for-djs", page: "SongRequestAppForDjs" },
  { path: "/dj-song-request", page: "DjSongRequest" },
  { path: "/dj-song-request-system", page: "DjSongRequestSystem" },
  { path: "/dj-request-system-explained", page: "DjRequestSystemExplained" },
  { path: "/best-dj-request-app", page: "BestDjRequestApp" },
  { path: "/best-dj-apps-2026", page: "BestDjApps2026" },
  { path: "/best-apps-for-djs-to-manage-song-requests-2026", page: "BestAppsForDjsToManageSongRequests2026" },
  { path: "/best-karaoke-apps-2026", page: "BestKaraokeApps2026" },
  { path: "/dj-request-vs-requestnow", page: "DjRequestVsRequestNow" },
  { path: "/dj-request-vs-limedj", page: "DjRequestVsLimeDj" },
  { path: "/dj-request-vs-nosongrequests", page: "DjRequestVsNoSongRequests" },
  { path: "/dj-request-vs-djfy", page: "DjRequestVsDjfy" },
  { path: "/dj-request-vs-requestsongs", page: "DjRequestVsRequestSongs" },
  { path: "/dj-request-vs-crowddj", page: "DjRequestVsCrowdDj" },
  { path: "/dj-request-vs-mydjdrop", page: "DjRequestVsMyDjDrop" },
  { path: "/dj-request-vs-presto", page: "DjRequestVsPresto" },
  { path: "/why-paid-song-requests-work", page: "WhyPaidSongRequestsWork" },
  { path: "/do-paid-song-requests-actually-work", page: "DoPaidSongRequestsActuallyWork" },
  { path: "/how-much-to-charge-for-song-requests", page: "HowMuchToChargeForSongRequests" },
  { path: "/how-to-make-more-money-djing", page: "HowToMakeMoreMoneyDjing" },
  { path: "/how-to-make-money-as-a-dj-from-song-requests", page: "HowToMakeMoneyAsADjFromSongRequests" },
  { path: "/dj-tip-app", page: "DjTipApp" },
  { path: "/how-djs-handle-song-requests-at-weddings", page: "HowDjsHandleSongRequestsAtWeddings" },
  { path: "/how-to-take-song-requests-at-a-wedding-reception", page: "HowToTakeSongRequestsAtWeddingReception" },
  { path: "/most-requested-songs-at-weddings", page: "MostRequestedSongsAtWeddings" },
  { path: "/dj-request-app-for-weddings", page: "DjRequestAppForWeddings" },
  { path: "/how-to-stop-bad-song-requests-at-clubs", page: "HowToStopBadSongRequestsAtClubs" },
  { path: "/qr-code-song-requests-vs-texting-the-dj", page: "QrCodeSongRequestsVsTextingTheDj" },
  { path: "/how-djs-manage-song-requests", page: "HowDjsManageSongRequests" },
  { path: "/best-way-to-handle-song-requests-as-a-dj", page: "BestWayToHandleSongRequestsAsADj" },
  { path: "/dj-song-request-etiquette", page: "DjSongRequestEtiquette" },
  { path: "/how-to-get-more-song-requests", page: "HowToGetMoreSongRequests" },
  { path: "/dj-request-app-for-bars", page: "DjRequestAppForBars" },
  { path: "/dj-request-app-for-clubs", page: "DjRequestAppForClubs" },
  { path: "/dj-request-app-for-private-events", page: "DjRequestAppForPrivateEvents" },
  { path: "/dj-request-app-for-latin-djs", page: "DjRequestAppForLatinDjs" },
  { path: "/dj-request-app-for-mobile-djs", page: "DjRequestAppForMobileDjs" },
  { path: "/dj-request-app-for-event-venues", page: "DjRequestAppForEventVenues" },
  { path: "/event-organizers", page: "EventOrganizers" },
  { path: "/corporate-event-dj-app", page: "CorporateEventDjApp" },
  { path: "/school-dance-dj-app", page: "SchoolDanceDjApp" },
  { path: "/prom-dj-app", page: "PromDjApp" },
  { path: "/birthday-party-dj-app", page: "BirthdayPartyDjApp" },
  { path: "/quinceanera-dj-app", page: "QuinceaneraDjApp" },
  { path: "/holiday-party-dj-app", page: "HolidayPartyDjApp" },
  { path: "/baby-shower", page: "BabyShower" },
  { path: "/brewery-dj-app", page: "BreweryDjApp" },
  { path: "/roller-rinks", page: "RollerRinks" },
  { path: "/silent-disco", page: "SilentDisco" },
  { path: "/live-bands", page: "LiveBands" },
  { path: "/live-bands-nashville-tn", page: "LiveBandsNashville" },
  { path: "/country-music-song-requests", page: "CountryMusicSongRequests" },
  { path: "/line-dancing-dj-app", page: "LineDancingDjApp" },
  { path: "/dj-request-app-for-line-dancing", page: "DjRequestAppForLineDancing" },
  { path: "/swing-dance", page: "SwingDance" },
  { path: "/salsa-dance", page: "SalsaDance" },
  { path: "/bachata-dance", page: "BachataDance" },
  { path: "/latin-dance", page: "LatinDance" },
  { path: "/live-photo-wall", page: "LivePhotoWall" },
  { path: "/how-to-set-up-a-photo-wall-at-a-live-event", page: "HowToSetUpPhotoWallAtLiveEvent" },
];

/** Client-only routes. `auth` routes are wrapped in RequireAuth. */
export const APP_ROUTES = [
  { path: "/join/:code", page: "Join" },
  { path: "/return", page: "Return" },
  { path: "/wall/:code", page: "PhotoWall", auth: true },
  { path: "/wall/:code/*", page: "PhotoWall", auth: true },
  { path: "/album/:albumId", page: "AlbumPage" },
  { path: "/signin", page: "SignIn" },
  { path: "/support", page: "Support" },
  { path: "/feedback", page: "Feedback" },
  { path: "/dj", page: "DjDashboard", auth: true },
  { path: "/qr-poster", page: "QRPoster", auth: true },
];

export const NOT_FOUND_PAGE = "NotFound";

export const LEGACY_REDIRECTS = [...DEPRECATED_ROUTE_REDIRECTS.entries()].map(([from, to]) => ({
  from,
  to,
}));

export const NOINDEX_ROUTES = [...FORCE_NOINDEX_ROUTES.entries()].map(([path, title]) => ({
  path,
  title,
}));

export function findPublicRoute(pathname = "/") {
  const clean = String(pathname || "/").replace(/\/+$/, "") || "/";
  return PUBLIC_ROUTES.find((route) => route.path === clean) || null;
}

export function pageSourcePath(page) {
  return `src/pages/${page}.jsx`;
}
